import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import cn from 'classnames';
import Icon from 'antd/lib/icon';

@translate()
export default class HorizontalSelect extends Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    currentIdx: PropTypes.number.isRequired,
    onChangeYear: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      currentIdx: props.currentIdx,
    };
  }

  onIncrement = () => {
    const { data, onChangeYear } = this.props;
    const { currentIdx } = this.state;
    if (currentIdx !== data.length - 1) {
      this.setState(prevState => ({
        currentIdx: prevState.currentIdx + 1,
      }));
      onChangeYear(data[currentIdx + 1]);
    }
  };

  onDecrement = () => {
    const { data, onChangeYear } = this.props;
    const { currentIdx } = this.state;
    if (currentIdx !== 0) {
      this.setState(prevState => ({
        currentIdx: prevState.currentIdx - 1,
      }));
      onChangeYear(data[currentIdx - 1]);
    }
  };

  render() {
    const { data, t } = this.props;
    const { currentIdx } = this.state;

    const previousDisabled = currentIdx === 0;
    const nextDisabled = currentIdx === data.length - 1;

    const classNamePrev = cn('ant-pagination-prev', {
      'ant-pagination-disabled': previousDisabled,
    });

    const classNameNext = cn('ant-pagination-next', {
      'ant-pagination-disabled': nextDisabled,
    });

    return (
      <ul className="ant-pagination ant-pagination-simple horizontal-select">
        <li
          title={t('Predchádzajúci rok')}
          className={classNamePrev}
          aria-disabled={previousDisabled}
          onClick={this.onDecrement}
        >
          <a>
            <Icon type="left" />
          </a>
        </li>
        <li className="ant-pagination-simple-pager">
          <label>{data[currentIdx]}</label>
        </li>
        <li
          title={t('Nasledujúci rok')}
          className={classNameNext}
          aria-disabled={nextDisabled}
          onClick={this.onIncrement}
          style={{ marginLeft: 7 }}
        >
          <a>
            <Icon type="right" />
          </a>
        </li>
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/HorizontalSelect.js